/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetMyPayoutWalletRow } from '../openapi-types.gen.js';
import { type useGetMyPayoutWalletArgs, useGetMyPayoutWalletSpec } from '../specs/users.spec.gen.js';

export type { GetMyPayoutWalletRow } from '../openapi-types.gen.js';
export type { useGetMyPayoutWalletArgs } from '../specs/users.spec.gen.js';


const _useGetMyPayoutWallet = createHook(useGetMyPayoutWalletSpec);
export const useGetMyPayoutWallet = _useGetMyPayoutWallet as (args: useGetMyPayoutWalletArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetMyPayoutWallet>;


/**
 * Hover/intent prefetch companion for `useGetMyPayoutWallet`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetMyPayoutWallet();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetMyPayoutWallet = createPrefetchHook(useGetMyPayoutWalletSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetMyPayoutWalletArgs>;
